export default __webpack_public_path__ + "static/media/low.823d3095.png";